import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import {
  needUpdateAction,
  resetStatDataAction,
  resetStatisticsDataset,
  resetStatSelectsAction,
  setEmptyStatisticsDataAction,
} from 'store/actions/mainPage';
import {
  getLayersAction,
  langUpdateAteLayerAction,
  resetATEAction,
  resetAteListAction,
  resetCurrentsAteAction,
  resetFoundLayerAction,
  setCurrentLayerAction,
} from 'store/actions/layers';
import { resetClusterPointsAndInfoAction } from 'store/actions/vectorLayers';
import { resetDynamicSeries } from 'store/actions/dynamicSeries';
import { setTransitionsData } from 'store/actions/transitData';
import { LayersSelect } from 'components/LayersTab/LayersSelect';
import { LayersBlock } from 'components/LayersTab/LayersBlock';
import { Box, CircularProgress } from '@mui/material';

export const LayersTab: React.FC = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { isLogged, needUpdate } = useAppSelector((state) => state.mainPage);
  const { clusterInfo } = useAppSelector((state) => state.searchTab);
  const { foundPoints } = useAppSelector((state) => state.vectorLayers);
  const { from } = useAppSelector((state) => state.transitData);
  const {
    loading,
    currAteRegion,
    currAteCity,
    currAteVC,
    currentYear,
    foundInfo,
    currentLayerId,
    allChildren,
  } = useAppSelector((state) => state.layers);

  useEffect(() => {
    const layer: any = allChildren.find((d) => d.id === currentLayerId);
    dispatch(
      setTransitionsData({
        dataset: Number(layer?.dataset || 0),
        ateRegion: Number(currAteRegion?.id || 0),
        ateRegionType: currAteRegion?.type,
        ateCity: Number(currAteCity?.id || 0),
        ateCityType: currAteCity?.type,
        layer: Number(currentLayerId || 0),
        ateVC: Number(currAteVC?.id || 0),
        from: 'layers',
        needShowAte: false,
      })
    );
  }, [currAteRegion, currAteCity, currentLayerId, currAteVC]);

  useEffect(() => {
    if (needUpdate) {
      const clusterInfoVL =
        clusterInfo.info && foundPoints
          ? {
              gid: clusterInfo.gid,
              layerId: currentLayerId,
              isLog: isLogged,
            }
          : undefined;

      dispatch(getLayersAction(isLogged, currentYear)).then(() => {
        dispatch(
          langUpdateAteLayerAction(
            currAteRegion,
            currAteCity,
            currAteVC,
            !!foundInfo,
            clusterInfoVL
          )
        );
      });
    }
  }, [needUpdate]);

  useEffect(() => {
    dispatch(resetStatSelectsAction()); //reset statistics selects
    dispatch(resetStatisticsDataset());
    dispatch(resetStatDataAction());
    dispatch(needUpdateAction(true));
    dispatch(resetCurrentsAteAction());
    dispatch(setCurrentLayerAction('', '', 0, '', '', '', '', '', '', 0, 0));
    dispatch(setEmptyStatisticsDataAction(false));

    return () => {
      dispatch(resetATEAction());
      // dispatch(resetAteListAction('ateCities', 'currAteCity')); //reset layers select options
      // dispatch(resetAteListAction('ateVC', 'currAteVC'));
      // dispatch(resetCurrentsAteAction());
      // dispatch(setCurrentLayerAction('', '', 0, '', '', '', '', '', '', 0, 0));
      dispatch(resetFoundLayerAction());
      dispatch(resetClusterPointsAndInfoAction());
      dispatch(resetDynamicSeries());
    };
  }, []);

  return (
    <Box>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <>
          <LayersSelect />
          <LayersBlock />
        </>
      )}
    </Box>
  );
};
